import { PickUpParcelCodeDto } from 'types/dtos/pickup-parcel'
import { PickUpParcelCodeModel } from 'types/models/pickup-parcel'

export const transformPickUpParcelCode = (
  response: PickUpParcelCodeDto,
): PickUpParcelCodeModel => ({
  imageUrl: response.image_url,
  code: response.code,
})
